export default "__VITE_ASSET__BYH3xMbr__"